// Prefixes app-internal API paths with the Next basePath when set.
// Use for any fetch() call to routes served by this Next app (e.g. /api/*).
// Do NOT use for absolute URLs or WP API calls (those go via NEXT_PUBLIC_API_DOMAIN).
export function apiPath(path: string): string {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH || "";
  return `${basePath}${path}`;
}